import React from 'react';

import DateTime from './date-time/DateTime';

import NotificationsContainer from '../../../containers/notifications/Notifications.container';
import ProfileContainer from '../../../containers/profile/Profile.container';

import { ReactComponent as BellRingingIcon } from '../../../resources/icons/bell-ringing.svg';
import { ReactComponent as BellIcon } from '../../../resources/icons/bell.svg';
import { ReactComponent as GearIcon } from '../../../resources/icons/gear.svg';
import { ReactComponent as UserIcon } from '../../../resources/icons/user.svg';
import logo from '../../../resources/images/logo-white.png';

import './header.scss';

type Props = {
  showNotifications: boolean;
  showProfile: boolean;
  newNotifications: boolean;
  toggleNotifications: () => void;
  toggleProfile: () => void;
  navigateToSettings: () => void;
};

const Header = ({
  showNotifications,
  showProfile,
  newNotifications,
  toggleNotifications,
  toggleProfile,
  navigateToSettings
}: Props) => {
  return (
    <div className="header">
      <img className="header__logo" src={logo} alt="PASTime App Logo" />
      <DateTime />
      <div className="header__icon-container">
        <GearIcon onClick={navigateToSettings} data-testid="gear-icon" />
        {newNotifications && <BellRingingIcon onClick={toggleNotifications} data-testid="bell-ringing-icon" />}
        {!newNotifications && <BellIcon onClick={toggleNotifications} data-testid="bell-icon" />}
        <UserIcon onClick={toggleProfile} data-testid="user-icon" />
      </div>

      <NotificationsContainer show={showNotifications} />
      <ProfileContainer show={showProfile} />
    </div>
  );
};

export default Header;
